module.exports = __webpack_public_path__ + "img/acc2.f1c09cd0.png";